module.exports = __webpack_public_path__ + "static/media/djurgardsfestivalen_2026.1232c185.jpg";